import React, { Component } from 'react';

import { connect } from 'react-redux';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import actions from '@/redux/action';
import sentGAEvent from '@/ga';
import Convert from './convert/Convert';
import ToGIF from './toGIF/ToGIF';
import DynamicPhoto from './dynamicPhoto/DynamicPhoto';
import AddLipShape from './addLipShape/AddLipShape';
import AudioCompress from './audioCompress/AudioCompress';
import AudioExtractor from './audioExtractor/AudioExtractor';
import ScreenRecorder from './screenRecorder/ScreenRecorder';
import AudioJoiner from './audioJoiner/AudioJoiner';
import AudioCutAndSpeedAndVolume from './audioCutAndSpeedAndVolume/AudioCutAndSpeedAndVolume';
import AudioAddMusic from './audioAddMusic/AudioAddMusic';
import VideoCompress from './videoCompress/VideoCompress';
import VideoMute from './videoMute/VideoMute';
import ImageCutout from './imageCutout/ImageCutout';
import Cookies from 'js-cookie';
import PurchaseModal from '../components/common/purchaseModal/PurchaseModal';
import {
  requsetGetAnonymousSessions,
  requsetGetProfile,
  requsetGetSubscription,
  googleCallback,
} from '@/api/apis';
import api_domain_config from '@/constants/common';
import '../assets/home.less';
import Utils from '../utils';
import LoginComponent from './allCommon/login';
import Device from 'current-device';
import V1cart from '@/utils/V1cart';
import NewPurchaseDialog from './common/Dialog/index';
import { loginWithToken } from '../api/apis';
import { message } from 'antd';
class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  getQueryVariable(variable, url) {
    //拿链接参数
    let urlParams;
    let result = '';
    if (url) {
      result = url.split('?');
    } else {
      result = window.location.href.split('?');
    }
    if (result.length > 2) {
      urlParams = result[2] + '?' + result[3];
    } else {
      urlParams = result[1];
    }
    if (!urlParams) return false;
    let vars = urlParams.split('&');

    for (let i = 0; i < vars.length; i++) {
      let pair = vars[i].substring(0, vars[i].indexOf('='));
      if (pair === variable) {
        return vars[i].substring(vars[i].indexOf('=') + 1, vars[i].length);
      }
    }
    return false;
  }
  componentDidMount() {
    const _this = this;
    // 监听页面所有点击事件，并且是a标签，a标签的链接必须有purchase, 才进行拦截处理，传参到购买页面
    document.body.addEventListener('click', function (event) {
      var targetDom = event.target || event.srcElement; // 兼容处理
      if (
        targetDom.nodeName.toLocaleLowerCase() === 'a' &&
        targetDom.href.indexOf('v2/account.html') >= 0
      ) {
        // 判断是否匹配目标元素
        if (event.preventDefault) {
          // 对捕获到的 a 标签进行处理
          event.preventDefault();
        } else {
          window.event.returnValue = true;
        }
        const targetHref = targetDom.href;
        const sourceValue = _this.getQueryVariable('source', targetHref);
        const cart = V1cart('', true);
        cart.reason = 9;
        if (sourceValue && sourceValue.indexOf('#') >= 0) {
          cart.channel = sourceValue.split('#')[0];
        }
        delete cart.cycle;
        let __s = Object.keys(cart)
          .map((v) => {
            return `track[${v}]=${cart[v]}`;
          })
          .join('&');
        const target = targetDom.target;
        let result = `${__s}`;
        let href = '';
        if (targetDom.href.indexOf('?') >= 0) {
          href = targetDom.href + '#&' + result;
        } else {
          href = targetDom.href + '#?' + result;
        }
        if (target === '_blank') {
          window.open(href);
        } else {
          window.location.href = href;
        }
      }
    });
    console.log(this.props.work);
    this.workPageGA(this.props.work);
    this.handleInitUserInfo();
    //注册退出事件，
    window.removeInfo = this.handleLogout;
    if (window.location.href.split('?')[1] !== undefined) {
      const code = this.getQueryVariable('code');
      const state = this.getQueryVariable('state');
      if (code && state) {
        googleCallback({ code: code, state: state }).then((obj) => {
          if (obj.code === 200) {
            let hostname = window.location.hostname;
            Cookies.set('authorization', obj.data.authorization, {
              expires: 30,
            });
            Cookies.set('access_token', obj.data.account_access_token, {
              expires: 30,
              domain: hostname.substring(
                hostname.indexOf('.'),
                hostname.length
              ),
            });
            let expires_in = new Date().getTime() + 30 * 86400 * 1000;
            Cookies.set('access_token_expires_in', expires_in.toString(), {
              expires: 30,
              domain: window.location.hostname.substring(
                window.location.hostname.indexOf('.'),
                window.location.hostname.length
              ),
            });
            this.props.onAuthorizationChange(obj.data.authorization);
            let res = {
              visible: true,
            };
            if (this.props.work === 'dynamic-photo') {
              this.props.onExceed2M(res);
            }
          }
          if (obj.code === 403101) {
            this.props.onSignUpModal({
              visible: true,
              step: 6,
            });
            this.props.onSaveEmail({ email: obj.data.email });
            localStorage.setItem('googleId', obj.data.id);
          }
          if (obj.code === 403102) {
            this.props.onSignUpModal({
              visible: true,
              step: 2,
            });
            message.error(this.props.t('userLoginTips:403102'));
          }
          let result = window.location.href.split('?');
          if (result.length > 2) {
            window.history.replaceState({}, '', result[0] + '?' + result[1]);
          } else {
            window.history.replaceState({}, '', result[0]);
          }
        });
      }
    }
    let access_token = Cookies.get('access_token');
    let expire_at = Cookies.get('access_token_expires_in');
    let authorization = Cookies.get('authorization');
    if (access_token && !authorization && expire_at) {
      let formData = new FormData();
      formData.append('account_token', access_token);
      formData.append(
        'expire_at',
        Math.floor(Number(Cookies.get('access_token_expires_in')) / 1000)
      );
      loginWithToken(formData).then((obj) => {
        if (obj.code === 200) {
          let hostname = window.location.hostname;
          Cookies.set('authorization', obj.data.authorization, {
            expires: 30,
          });
          Cookies.set('access_token', obj.data.account_access_token, {
            expires: 30,
            domain: hostname.substring(hostname.indexOf('.'), hostname.length),
          });
          let expires_in = new Date().getTime() + 30 * 86400 * 1000;
          Cookies.set('access_token_expires_in', expires_in.toString(), {
            expires: 30,
            domain: window.location.hostname.substring(
              window.location.hostname.indexOf('.'),
              window.location.hostname.length
            ),
          });
          this.props.onAuthorizationChange(obj.data.authorization);
        }
      });
    }
  }

  /**
   *  退出登录
   */
  handleLogout = () => {
    this.props.onProfileObjChange(null);
    this.props.onSubscriptionChange(null);
    this.props.onAuthorizationChange(null);
    this.getToken();
  };

  /**
   * 用户进来本页面，登录流程
   */
  handleInitUserInfo = () => {
    //如果当前内存中没有 authorization, 则是说明没有登录，直接获取token用作路人身份
    if (!Cookies.get('authorization')) {
      this.getToken();
    } else {
      if (Cookies.get('anonymousAuth')) {
        Cookies.remove('anonymousAuth', { domain: api_domain_config.DOMAIN });
        Cookies.remove('videoEditorTimes', {
          domain: api_domain_config.DOMAIN,
        });
      }
      this.getProfile();
      this.getSubscription();
    }
  };

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.authorization !== this.props.authorization) {
      if (Cookies.get('authorization')) {
        if (Cookies.get('anonymousAuth')) {
          Cookies.remove('anonymousAuth', { domain: api_domain_config.DOMAIN });
          Cookies.remove('videoEditorTimes', {
            domain: api_domain_config.DOMAIN,
          });
        }
        this.handleInitUserInfo();
      }
    }
    if (
      this.props.exceed2MVisible.visible !==
        prevProps.exceed2MVisible.visible &&
      !this.props.exceed2MVisible.visible
    ) {
      if (Cookies.get('authorization')) {
        this.handleInitUserInfo();
      }
    }
    if (
      this.props.purchaseModalObj.visible !==
        prevProps.purchaseModalObj.visible &&
      !this.props.purchaseModalObj.visible
    ) {
      if (Cookies.get('authorization')) {
        this.handleInitUserInfo();
      }
    }
  }

  /**
   * 请求获取用户个人信息
   */
  getProfile = () => {
    requsetGetProfile()
      .then((res) => {
        if (res.code === 200) {
          this.setState({ show: true });
          this.props.onProfileObjChange(res.data);
          let hasAccount = document.querySelectorAll('.has-account');
          let noAccount = document.querySelectorAll('.no-account');
          if (hasAccount.length && noAccount.length) {
            hasAccount.forEach(function (elem) {
              if (res.data.nickname) {
                elem.querySelector('.user-name').innerHTML = res.data.nickname;
              }
              elem.querySelector('.user-email').innerHTML = res.data.email;
              elem.classList.replace('d-none', 'd-flex');
            });

            noAccount.forEach(function (elem) {
              elem.classList.replace('d-flex', 'd-none');
            });
          }
        } else {
          // localStorage.removeItem("authorization");
          this.getToken();
        }
      })
      .catch((err) => {
        this.getToken();
      });
  };

  /**
   * 请求获取用户订阅信息
   */
  getSubscription = () => {
    requsetGetSubscription({
      from_product:
        this.props.work === 'screen-recorder'
          ? 11
          : this.props.work === 'dynamic-photo'
          ? 15
          : 1,
    })
      .then((res) => {
        if (res.code === 200) {
          this.props.onSubscriptionChange(res.data.subscription);
          console.log('res.data.subscription', res.data.subscription);
          let hasAccount = document.querySelectorAll('.has-account');
          if (
            res.data.subscription &&
            res.data.subscription[0].status === 'Active'
          ) {
            hasAccount.forEach(function (elem) {
              elem.querySelector('.vip').classList.replace('d-none', 'd-flex');
              elem.querySelector('.user').classList.replace('d-flex', 'd-none');
            });
            let upGradeBtns = document.querySelectorAll('.account-upgrade');
            if (upGradeBtns && upGradeBtns.length) {
              upGradeBtns.forEach(function (elem) {
                elem.style = 'display: none !important';
              });
            }
          } else {
            hasAccount.forEach(function (elem) {
              elem.querySelector('.vip').classList.replace('d-flex', 'd-none');
              elem.querySelector('.user').classList.replace('d-none', 'd-flex');
            });
          }
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  /**
   * 获取Token
   */
  getToken = () => {
    if (!Cookies.get('anonymousAuth')) {
      requsetGetAnonymousSessions()
        .then((res) => {
          Cookies.set('anonymousAuth', res.data.authorization, {
            expires: 1,
            domain: api_domain_config.DOMAIN,
          });
          Cookies.set('videoEditorTimes', 0, {
            expires: 1,
            domain: api_domain_config.DOMAIN,
          });
          Cookies.set('imageCutoutTimes', 0, {
            expires: 1,
            domain: api_domain_config.DOMAIN,
          });
          this.props.onAuthorizationChange(res.data.authorization);
          this.props.onVideoEditorTimesChange(0);
          this.props.onImageCutoutTimesChange(0);
          this.setState({ show: true });
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      this.props.onTokenIdChange(window.Storage.get('tokenId'));
      this.setState({ show: true });
    }
  };

  workPageGA = (work) => {
    switch (work) {
      case 'audio-compress':
        sentGAEvent({
          category: 'EnterFuncPage',
          action: '28AC_EnterFuncPage',
          label: 'Null',
        });
        break;
      case 'audio-extractor':
        sentGAEvent({
          category: 'audio_extractor_page',
          action: 'audio_extractor_page_display',
        });
        sentGAEvent({
          category: 'EnterFuncPage',
          action: '26AE_EnterFuncPage',
          label: 'Null',
        });
        break;
      case 'audio-joiner':
        sentGAEvent({
          category: 'audio_merge_page',
          action: 'audio_merge_page_display',
        });
        sentGAEvent({
          category: 'EnterFuncPage',
          action: '27AM_EnterFuncPage',
          label: 'Null',
        });
        break;
      case 'audio-cut':
        sentGAEvent({
          category: 'audio_cut_page',
          action: 'audio_cut_page_display',
        });
        sentGAEvent({
          category: 'EnterFuncPage',
          action: '32AC_EnterFuncPage',
          label: 'Null',
        });
        break;
      case 'audio-speed':
        sentGAEvent({
          category: 'audio_speed_page',
          action: 'audio_speed_page_display',
        });
        sentGAEvent({
          category: 'EnterFuncPage',
          action: '31ACS_EnterFuncPage',
          label: 'Null',
        });
        break;
      case 'audio-volume':
        sentGAEvent({
          category: 'audio_volume_page',
          action: 'audio_volume_page_display',
        });
        sentGAEvent({
          category: 'EnterFuncPage',
          action: '30ACV_EnterFuncPage',
          label: 'Null',
        });
        break;
      case 'audio-add-music':
        sentGAEvent({
          category: 'EnterFuncPage',
          action: '33AM_EnterFuncPage',
        });
        break;
      case 'video-compress':
        sentGAEvent({
          category: 'EnterFuncPage',
          action: '24VC_EnterFuncPage',
        });
        sentGAEvent({
          category: 'EnterFuncPage',
          action: '24VC_EnterFuncPage',
          label: 'Null',
        });
        break;
      case 'video-mute':
        sentGAEvent({
          category: 'EnterFuncPage',
          action: '25VM_EnterFuncPage',
          label: 'Null',
        });
        break;
      case 'image-cutout':
        sentGAEvent({
          category: 'EnterFuncPage',
          action: '08BR_EnterFuncPage',
          label: 'Null',
        });
        break;
      case 'image-bg-changer':
        sentGAEvent({
          category: 'EnterFuncPage',
          action: '07BC_EnterFuncPage',
          label: 'Null',
        });
        break;
      case 'to-gif':
        sentGAEvent({
          category: 'EnterFuncPage',
          action: '37TG_EnterFuncPage',
          label: 'Null',
        });
        break;
      default:
        break;
    }
  };

  getWorkRender = (work) => {
    switch (work) {
      case 'convert-image':
        this.props.onWorkChange('convert');
        return <Convert type='image' />;
      case 'convert-video':
        this.props.onWorkChange('convert');
        return <Convert type='video' />;
      case 'convert-audio':
        this.props.onWorkChange('convert');
        return <Convert type='audio' />;
      case 'to-gif':
        this.props.onWorkChange('togif');
        return <ToGIF />;
      case 'dynamic-photo':
        this.props.onWorkChange('dynamicPhoto');
        return <DynamicPhoto />;
      case 'add-lip-shape':
        this.props.onWorkChange('addLipShape');
        return <AddLipShape />;
      case 'audio-compress':
        this.props.onWorkChange('audioCompress');
        return <AudioCompress />;
      case 'audio-extractor':
        this.props.onWorkChange('audioExtractor');
        return <AudioExtractor />;
      case 'audio-joiner':
        this.props.onWorkChange('audioJoiner');
        return <AudioJoiner />;
      case 'audio-cut':
        this.props.onWorkChange('audioCut');
        return <AudioCutAndSpeedAndVolume />;
      case 'audio-speed':
        this.props.onWorkChange('audioSpeed');
        return <AudioCutAndSpeedAndVolume />;
      case 'audio-volume':
        this.props.onWorkChange('audioVolume');
        return <AudioCutAndSpeedAndVolume />;
      case 'audio-add-music':
        this.props.onWorkChange('audioAddMusic');
        return <AudioAddMusic />;
      case 'video-compress':
        this.props.onWorkChange('videoCompress');
        return <VideoCompress />;
      case 'video-mute':
        this.props.onWorkChange('videoMute');
        return <VideoMute />;
      case 'image-cutout':
        this.props.onWorkChange('imageCutout');
        return <ImageCutout pageType='BGRemover' />;
      // background changer
      case 'image-bg-changer':
        this.props.onWorkChange('imageCutout');
        return <ImageCutout pageType='BGChanger' />;
      case 'screen-recorder':
        this.props.onWorkChange('screenRecorder');
        return <ScreenRecorder />;
      default:
        return '';
    }
  };

  render() {
    const { work, purchaseModalObj } = this.props;
    console.log(purchaseModalObj.visible);
    return (
      <>
        <div className='Home'>
          <DndProvider backend={HTML5Backend}>
            {this.getWorkRender(work)}
          </DndProvider>
          <PurchaseModal />
          <NewPurchaseDialog />
        </div>
        <LoginComponent />
      </>
    );
  }
}
const mapStateToPropos = (state) => ({
  currFile: state.files.currFile,
  purchaseModalObj: state.common.purchaseModalObj,
  authorization: state.common.authorization,
  exceed2MVisible: state.common.exceed2M,
});
const mapDispatchToProps = (dispatch) => ({
  onTokenIdChange: (tokenId) => dispatch(actions.onTokenIdChange(tokenId)),
  onWorkChange: (work) => dispatch(actions.onWorkChange(work)),
  onAuthorizationChange: (authorization) =>
    dispatch(actions.onAuthorizationChange(authorization)),
  onProfileObjChange: (profileObj) =>
    dispatch(actions.onProfileObjChange(profileObj)),
  onSubscriptionChange: (subscription) =>
    dispatch(actions.onSubscriptionChange(subscription)),
  onVideoEditorTimesChange: (videoEditorTimes) =>
    dispatch(actions.onVideoEditorTimesChange(videoEditorTimes)),
  onImageCutoutTimesChange: (imageCutoutTimes) =>
    dispatch(actions.onImageCutoutTimesChange(imageCutoutTimes)),
  onSignUpModal: (signUpModal) => dispatch(actions.onSignUpModal(signUpModal)),
  onSaveEmail: (email) => dispatch(actions.saveEmail(email)),
  onPurchaseModalObjChange: (purchaseModalObj) =>
    dispatch(actions.onPurchaseModalObjChange(purchaseModalObj)),
  onPayBill: (visible) => dispatch(actions.onPayBill(visible)),
  onExceed2M: (visible) => dispatch(actions.onExceed2M(visible)),
});

export default connect(mapStateToPropos, mapDispatchToProps)(Home);
